import styled from "styled-components";

import { colors } from "shared/ui";

export const Container = styled.div`
    max-width: 1128px;
    padding-bottom: 28px;
`;

export const HeaderActions = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
`;

export const SearchRow = styled.div`
    max-width: 420px;
    margin-bottom: 16px;
`;

export const Placeholder = styled.div`
    padding: 32px 8px;
    text-align: center;
    color: ${colors.textSecondary};
`;

